if (!customElements.get('collection-prefilters-slider')) {
  customElements.define(
    'collection-prefilters-slider',
    class CollectionPrefiltersSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.slider = this.querySelector('.collection-prefilters__slider');
        this.sliderInstance = null;
        this.initSlider();
      }

      initSlider() {
        if (!this.slider || typeof window.FoxTheme?.Carousel === 'undefined') return;

        const options = {
          slidesPerView: 2.5,
          spaceBetween: 16,
          breakpoints: {
            768: {
              slidesPerView: 4.5,
              spaceBetween: 16,
            },
            1280: {
              slidesPerView: 6.5,
              spaceBetween: 16,
            },
          },
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          threshold: 2,
          grabCursor: true,
          allowTouchMove: true,
        };

        this.sliderInstance = new window.FoxTheme.Carousel(this.slider, options);
        this.sliderInstance.init();
        this.slideToActive();
      }

      slideToActive() {
        if (!this.sliderInstance?.slider) return;
        const activeSlide = this.querySelector('.collection-prefilters__item--active');
        if (!activeSlide) return;

        const slide = activeSlide.closest('.swiper-slide');
        if (!slide) return;

        const index = Array.from(this.querySelectorAll('.swiper-slide')).indexOf(slide);
        if (index > -1) {
          this.sliderInstance.slider.slideTo(index, 0);
        }
      }

      disconnectedCallback() {
        if (this.sliderInstance?.slider) {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = null;
        }
      }
    }
  );
}
